import clsx from "clsx";
import { twMerge } from "tailwind-merge";
// This is referenced in bundled CSS file (check: table-react/postcss.config.js)
export const scopingClass = "__kalep__table";
export function cx(...classes) {
    return twMerge(clsx(scopingClass, classes));
}
